module.exports = __webpack_public_path__ + "img/bg (6).9e694429.jpg";